// Implements: F-UIX-018
/**
 * The value axis of a chart: a round step, at most five intervals, the top rounded up to it. Plain
 * numbers in, plain numbers out (money is converted by the caller, in the backoffice only).
 */

export interface Scale {
  readonly max: number;
  readonly ticks: readonly number[];
}

const MULTIPLIERS = [1, 2, 2.5, 5] as const;
const MAX_INTERVALS = 5;

export function niceScale(highest: number): Scale {
  if (!(highest > 0)) return { max: 1, ticks: [0, 1] };
  for (let exponent = Math.floor(Math.log10(highest)) - 1; ; exponent += 1) {
    for (const multiplier of MULTIPLIERS) {
      const step = multiplier * 10 ** exponent;
      const intervals = Math.ceil(highest / step - 1e-9);
      if (intervals <= MAX_INTERVALS) {
        const ticks = Array.from({ length: intervals + 1 }, (_, index) => Number((index * step).toFixed(10)));
        return { max: ticks[intervals] ?? step, ticks };
      }
    }
  }
}
